import React, {ChangeEvent} from "react";
import {Input, message} from "antd";
import "../DynamicForm.scss";
import {TextElementProps} from "@data-force/app";
import {connect} from "react-redux";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = TextElementProps & DispatchProps;

class TextAreaElement extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.textAreaChangeHandler = this.textAreaChangeHandler.bind(this);
    }

    textAreaChangeHandler({target: {value}}: ChangeEvent<HTMLTextAreaElement>): void {
        const {
            fieldName, index, refElements, onSave,
        }: TextElementProps = this.props;
        this.props.onChange({
            fieldName, value, index, refElements,
        });
        if (onSave) {
            onSave({
                fieldName,
                index,
                changeValue: value,
            });
        }
        message.destroy();
        this.props.clearAlerts();
    }

    render() {
        const {
            value, className = "", readOnly,
        }: TextElementProps = this.props;

        return (
            <Input.TextArea
                className={className}
                value={value}
                autoSize={{
                    minRows: 3,
                    maxRows: 5,
                }}
                onChange={this.textAreaChangeHandler}
                disabled={readOnly}
            />
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(TextAreaElement);
